// extracted by mini-css-extract-plugin
export default {"wrapper":"H0-z","play":"I0-z"};